/**
 * @generated SignedSource<<5df7999367545847e34cf31a4388ef56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TierType = "LITE" | "PRO" | "CORE" | "ENTERPRISE" | "TRIAL" | "FREE_FOREVER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BudgetData_company$data = {
  readonly tier: TierType | null;
  readonly " $fragmentSpreads": FragmentRefs<"HighLevelBudgetNumbers_company">;
  readonly " $fragmentType": "BudgetData_company";
};
export type BudgetData_company$key = {
  readonly " $data"?: BudgetData_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"BudgetData_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BudgetData_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tier",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HighLevelBudgetNumbers_company"
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "8eb87cf1eb410c763f34620fbc3e621a";

export default node;
